import { useMemo } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '../tabs';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexWrap: 'wrap',
    },
  },
  headerLeft: {
    flexGrow: 1,
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
    },
  },
  title: {
    margin: 0,
  },
  subtitle: {
    fontSize: 12,
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
  },
  lockIcon: {
    width: 12,
    height: 12,
    marginRight: theme.spacing(0.5),
    paddingBottom: 2,
    opacity: 0.8,
  },
  tabs: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: theme.spacing(2),
    },
  },
  titleLink: {
    color: 'rgba(0, 0, 0, 0.87)',
    textDecoration: 'none',
  },
  calendarWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  calendarPendingBadge: {
    borderRadius: 10,
    height: 20,
    minWidth: 20,
    padding: theme.spacing(0, 0.75),
    fontSize: '0.75rem',
    backgroundColor: theme.palette.error.main,
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: theme.spacing(0.5),
  },
}));

const GroupHeader = (props) => {
  const { group, tab } = props;
  const classes = useStyles();

  const tabOptions = useMemo(() => {
    let options = [
      {
        label: 'Overview',
        value: 'overview',
        href: `/groups/${group.slug}`,
      },
      {
        label: (
          <span className={classes.calendarWrapper}>
            Calendar ({group.upcomingEventsCount})
            {Boolean(group.pendingUpcomingEventsCount) && group.pendingUpcomingEventsCount > 0 && (
              <span className={classes.calendarPendingBadge}>
                {group.pendingUpcomingEventsCount}
              </span>
            )}
          </span>
        ),
        value: 'calendar',
        href: `/groups/${group.slug}/calendar`,
      },
    ];
    if (group.permissions.accessible) {
      options.push({
        label: `Discussion${group.recentPostsCount > 0 ? ` (${group.recentPostsCount} recent)` : ''}`,
        value: 'posts',
        href: `/groups/${group.slug}/posts`,
      });
      options.push({
        label: 'Photos',
        value: 'photos',
        href: `/groups/${group.slug}/photos`,
      });
    }
    return options;
  }, [group]);

  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <Typography variant="h1" className={classes.title}>
          <Link
            href="/groups/[slug]"
            as={`/groups/${group.slug}`}
            className={classes.titleLink}
          >
            {group.name}
          </Link>
        </Typography>
        <div className={classes.subtitle}>
          {!group.public && (
            <img src="/static/lock-solid.svg" className={classes.lockIcon} />
          )}
          {group.found ? 'Found' : (group.public ? 'Public' : 'Private')} Group
        </div>
      </div>

      {!group.found && (
        <Tabs
          options={tabOptions}
          tab={tab}
          className={classes.tabs}
          links
        />
      )}
    </div>
  );
};

GroupHeader.propTypes = {
  group: PropTypes.object,
  tab: PropTypes.string,
};

export default GroupHeader;
